module.exports = __webpack_public_path__ + "static/media/advantageDetailTitle.1779d265.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/advantageDetailTitle.png
// module id = 904
// module chunks = 0